// client/src/context/types.js
// Auth
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL';

// Lodges
export const GET_LODGES = 'GET_LODGES';
export const GET_LODGE = 'GET_LODGE';
export const LODGE_ERROR = 'LODGE_ERROR';
export const CLEAR_LODGE = 'CLEAR_LODGE';
export const FILTER_LODGES = 'FILTER_LODGES';
export const CLEAR_FILTER = 'CLEAR_FILTER';

// News
export const GET_NEWS = 'GET_NEWS';
export const GET_ARTICLE = 'GET_ARTICLE';
export const NEWS_ERROR = 'NEWS_ERROR';
export const CLEAR_NEWS = 'CLEAR_NEWS';

// Events
export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENT = 'GET_EVENT';
export const EVENT_ERROR = 'EVENT_ERROR';
export const CLEAR_EVENT = 'CLEAR_EVENT';
export const RSVP_SUCCESS = 'RSVP_SUCCESS';
export const RSVP_ERROR = 'RSVP_ERROR';

// Resources
export const GET_RESOURCES = 'GET_RESOURCES';
export const GET_RESOURCE = 'GET_RESOURCE';
export const RESOURCE_ERROR = 'RESOURCE_ERROR';
export const CLEAR_RESOURCE = 'CLEAR_RESOURCE';
export const DOWNLOAD_START = 'DOWNLOAD_START';
export const DOWNLOAD_SUCCESS = 'DOWNLOAD_SUCCESS';
export const DOWNLOAD_ERROR = 'DOWNLOAD_ERROR';

// Layout/UI
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const TOGGLE_THEME = 'TOGGLE_THEME';
export const SET_LOADING = 'SET_LOADING';
